module.exports = __webpack_public_path__ + "static/media/09-03.3c1102c6.png";